import { makeStyles } from '@material-ui/core/styles';
import hexRgba from 'hex-rgba';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';
import IconAlertTriangle from '../../assets/images/Icons/IconAlertTriangle';
import IconInfo from '../../assets/images/Icons/IconInfo';

const useStyles = makeStyles(
  () => ({
    tip: {
      backgroundColor: hexRgba(color.$15, 10),
      padding: '13px 16px',
      borderRadius: '4px',
    },
    top: {
      display: 'flex',
      alignItems: 'center',
      color: '#177484',
      fontWeight: '500',
      fontSize: '15px',
      lineHeight: '21px',
      marginBottom: 4,
    },
    tipText: {
      color: '#177484',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',
      paddingLeft: 34,
    },
  }),
  {
    name: 'Tip',
  },
);

const Tip = ({ style = {}, title, text, type = 'info' }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  switch (type) {
    case 'alert':
      return (
        <div
          style={{ backgroundColor: hexRgba(color.$18, 10), ...style }}
          className={classes.tip}
        >
          <div className={classes.top} style={{ color: color.$18 }}>
            <IconAlertTriangle style={{ marginRight: 12 }} color={color.$18} />
            {title || t('tipTitle')}
          </div>
          <div className={classes.tipText} style={{ color: color.$18 }}>
            {text}
          </div>
        </div>
      );
    case 'info':
    default:
      return (
        <div style={style} className={classes.tip}>
          <div className={classes.top}>
            <IconInfo
              style={{ marginRight: 12 }}
              hoverColor={color.$15}
              color={color.$15}
            />
            {title || t('tipTitle')}
          </div>
          <div className={classes.tipText}>{text}</div>
        </div>
      );
  }
};

export default Tip;
